import React from 'react';
import { useSelector } from 'react-redux';

import LogIn from './LogIn';

export default function Home() {
  const is_logged_in = useSelector(state => state.app.is_logged_in);
  const user = useSelector(state => state.user);
  const account = useSelector(state => state.account);

  return (
    <>
    {!is_logged_in &&
      <>
      <div id="content" className="container py-5">
            <LogIn/>
      </div>
     </>
    }
    {is_logged_in &&
      <>
      <div id="content" className="container py-5">
        <div className="row pt-5 mt-4">
          <div className="col-md-6">
            <h2 className="h4"><i className="fa-solid fa-tachograph-digital"></i> Dashboard</h2>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col">
            {user.first_name} {user.last_name}<br/>
            {account.timezone}<br/>
            {user.email}<br/>
          </div>
        </div>


        <div className="row mt-4">
          <div className="col">
            <div className="card h-100">
              <div className="card-header bg-dark h4 text-white">
                START HERE
              </div>
              <div className="card-body">
                <ol>
                  <li><a href="https://dig.linkoln.it/yaK6uC">LINKOLN your first email</a></li>
                  <li><a href="https://dig.linkoln.it/uuHTdg">Create a new LINK PREVIEW</a></li>
                  <li>Update or delete a live message... (coming soon)</li>
                  <li>Daily opened report (coming soon)</li>
                  <li>Linkoln roadmap (coming soon)</li>
                </ol>
                <p><small className="text-danger fst-italic">*please note that the ‘from address’ must match the same address that you confirmed your registration with ({user.email}).</small></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      </>
    }
  </>);
}

